import {numberFormat} from "@pg-mono/string-utils";

// every gridline shows its own price - abbreviating to "N tys." collapses neighbouring ticks into one label as soon as the
// axis steps by less than a thousand
export const formatPriceAxisLabel = (value: number): string => numberFormat(value, {precision: 0}) ?? String(value);

// integer ticks keep the labels apart when the whole series fits inside a few złotych, but Highcharts centres a flat series
// on a single gridline only while decimals stay allowed - forcing integers there gives two gridlines a złoty apart instead
export const getPriceAxisAllowDecimals = (values: readonly number[]): false | undefined => {
    const prices = values.filter((value) => Number.isFinite(value));

    return prices.length > 0 && Math.max(...prices) !== Math.min(...prices) ? false : undefined;
};
import {numberFormat} from "@pg-mono/string-utils";

// every gridline shows its own price - abbreviating to "N tys." collapses neighbouring ticks into one label as soon as the
// axis steps by less than a thousand
export const formatPriceAxisLabel = (value: number): string => numberFormat(value, {precision: 0}) ?? String(value);

// integer ticks keep the labels apart when the whole series fits inside a few złotych, but Highcharts centres a flat series
// on a single gridline only while decimals stay allowed - forcing integers there gives two gridlines a złoty apart instead
export const getPriceAxisAllowDecimals = (values: readonly number[]): false | undefined => {
    const prices = values.filter((value) => Number.isFinite(value));

    return prices.length > 0 && Math.max(...prices) !== Math.min(...prices) ? false : undefined;
};
